export default __webpack_public_path__ + "static/curriculum-guide-preview-2-b9f39beb739fa1a65cd9acbdcab06e14.jpg";